var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishListWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 3.25L10.4297 2.82031C11.7188 1.53125 13.5547 0.945312 15.3125 1.25781C18.0078 1.6875 20 4.03125 20 6.76562V6.96094C20 8.60156 19.2969 10.1641 18.125 11.2578L11.0547 17.8594C10.7812 18.1328 10.3906 18.25 10 18.25C9.57031 18.25 9.17969 18.1328 8.90625 17.8594L1.83594 11.2578C0.664062 10.1641 0 8.60156 0 6.96094V6.76562C0 4.03125 1.95312 1.6875 4.64844 1.25781C6.40625 0.945312 8.24219 1.53125 9.53125 2.82031L9.96094 3.25ZM9.96094 5.04688L8.63281 3.67969C7.65625 2.70312 6.25 2.23438 4.84375 2.46875C2.77344 2.82031 1.21094 4.61719 1.21094 6.76562V6.96094C1.21094 8.25 1.75781 9.46094 2.69531 10.3203L9.76562 16.9219C9.80469 17 9.88281 17 9.96094 17C10.0781 17 10.1562 17 10.1953 16.9219L17.2656 10.3203C18.2031 9.46094 18.75 8.25 18.75 6.96094V6.76562C18.75 4.61719 17.1875 2.82031 15.1172 2.46875C13.7109 2.23438 12.3047 2.70312 11.3281 3.67969L9.96094 5.04688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListWhite);
export default __webpack_public_path__ + "static/media/WishListWhite.bdbb78739f64dbbf2aa5318961fed54c.svg";
export { ForwardRef as ReactComponent };